// hooks/useSmoothScroll.ts
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useSmoothScroll = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      
      if (element) {
        // Smooth scroll to element
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    } else {
      // Scroll to top if no hash
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [location]);
};

export default useSmoothScroll;